// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicTicketCombinationControllerCreateData } from './PublicTicketCombinationControllerCreateData.gen';
import type { PublicTicketCombinationControllerCreateErrors } from './PublicTicketCombinationControllerCreateErrors.gen';
import type { PublicTicketCombinationControllerCreateResponses } from './PublicTicketCombinationControllerCreateResponses.gen';
import type { PublicTicketCombinationControllerDeleteData } from './PublicTicketCombinationControllerDeleteData.gen';
import type { PublicTicketCombinationControllerDeleteErrors } from './PublicTicketCombinationControllerDeleteErrors.gen';
import type { PublicTicketCombinationControllerDeleteResponses } from './PublicTicketCombinationControllerDeleteResponses.gen';
import type { PublicTicketCombinationControllerGetAllData } from './PublicTicketCombinationControllerGetAllData.gen';
import type { PublicTicketCombinationControllerGetAllErrors } from './PublicTicketCombinationControllerGetAllErrors.gen';
import type { PublicTicketCombinationControllerGetAllResponses } from './PublicTicketCombinationControllerGetAllResponses.gen';
import type { PublicTicketCombinationControllerGetOneData } from './PublicTicketCombinationControllerGetOneData.gen';
import type { PublicTicketCombinationControllerGetOneErrors } from './PublicTicketCombinationControllerGetOneErrors.gen';
import type { PublicTicketCombinationControllerGetOneResponses } from './PublicTicketCombinationControllerGetOneResponses.gen';
import type { PublicTicketCombinationControllerGetShortTermTicketCombinationListData } from './PublicTicketCombinationControllerGetShortTermTicketCombinationListData.gen';
import type { PublicTicketCombinationControllerGetShortTermTicketCombinationListErrors } from './PublicTicketCombinationControllerGetShortTermTicketCombinationListErrors.gen';
import type { PublicTicketCombinationControllerGetShortTermTicketCombinationListResponses } from './PublicTicketCombinationControllerGetShortTermTicketCombinationListResponses.gen';
import type { PublicTicketCombinationControllerUpdateData } from './PublicTicketCombinationControllerUpdateData.gen';
import type { PublicTicketCombinationControllerUpdateErrors } from './PublicTicketCombinationControllerUpdateErrors.gen';
import type { PublicTicketCombinationControllerUpdateResponses } from './PublicTicketCombinationControllerUpdateResponses.gen';

export class PublicTicketCombinationController {
    /**
     * Get ticket combinations.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicTicketCombinationControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicTicketCombinationControllerGetAllResponses, PublicTicketCombinationControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-combinations',
            ...options
        });
    }
    
    /**
     * Create ticket combination.
     *
     * Require: `PERMISSION_TICKET-COMBINATIONS_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_VALID_TO** - ValidFrom is after ValidTo OR New ValidFrom is null or new validFrom is before old ValidFrom.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **INVALID_TARIFF_PROFILE** - Tariff profile does not exist.<br>
     * + **INVALID_PRICE_LIST** - Price list does not exist.<br>
     * + **INVALID_TICKET_COMBINATION** - Ticket combination does not exist, is expired or isn´t enable for sell.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<PublicTicketCombinationControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<PublicTicketCombinationControllerCreateResponses, PublicTicketCombinationControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-combinations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete ticket combination.
     *
     * If an entity is being used, 409 Conflict will be returned.<br>
     * Require: `PERMISSION_TICKET-COMBINATIONS_DELETE`
     */
    public static delete<ThrowOnError extends boolean = false>(options: Options<PublicTicketCombinationControllerDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<PublicTicketCombinationControllerDeleteResponses, PublicTicketCombinationControllerDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-combinations/{id}',
            ...options
        });
    }
    
    /**
     * Get ticket combination by id.
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<PublicTicketCombinationControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicTicketCombinationControllerGetOneResponses, PublicTicketCombinationControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-combinations/{id}',
            ...options
        });
    }
    
    /**
     * Update ticket combination.
     *
     * Require: `PERMISSION_TICKET-COMBINATIONS_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<PublicTicketCombinationControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<PublicTicketCombinationControllerUpdateResponses, PublicTicketCombinationControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-combinations/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get all possible combinations of short-term tickets for user. Which can be purchased in the mobile application.
     */
    public static getShortTermTicketCombinationList<ThrowOnError extends boolean = false>(options: Options<PublicTicketCombinationControllerGetShortTermTicketCombinationListData, ThrowOnError>) {
        return (options.client ?? client).get<PublicTicketCombinationControllerGetShortTermTicketCombinationListResponses, PublicTicketCombinationControllerGetShortTermTicketCombinationListErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/ticket-combinations-short-terms',
            ...options
        });
    }
}
